import MutateUpdateShortlists from '../../graphql/mutations/MutateUpdateShortlists';
import { mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  data: function () {
    return {
      shortlist: []
    };
  },
  computed: {
    ...mapGetters({
      shortlisted: 'shortList/getShortList',
      vehicleApplication: 'vehicleApplication/vehicleApplication'
    })
  },
  created() {
    this.shortlist = this.shortlisted;
  },
  watch: {
    // Sync local shortlist data with Vuex shortlisted getter
    // This ensures shortlist stays in sync when Vuex state changes externally
    shortlisted: {
      handler(newValue) {
        if (Array.isArray(newValue)) {
          this.shortlist = newValue;
        } else if (!newValue) {
          this.shortlist = [];
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      updateShortlistAction: 'shortList/updateShortList',
      clearShortList: 'shortList/clearShortList'
    }),
    ...mapMutations({
      setVehicleApplication: 'vehicleApplication/setVehicleApplication'
    }),
    updateShortList() {
      this.updateShortlistAction(this.shortlist);
    },
    async updateVehicleAppShortlist(shortlists) {
      this.vehicleApplication.calculator = {
        ...this.vehicleApplication.calculator,
        shortlists
      };

      this.setVehicleApplication(this.vehicleApplication);
    },
    async updateShortListDB(applicationId, userId) {
      this.updateShortlistAction(this.shortlist);
      this.updateVehicleAppShortlist(this.shortlist);

      try {
        await this.$apollo.mutate({
          mutation: MutateUpdateShortlists,
          variables: {
            applicationId,
            userId,
            shortlists: this.shortlist
          }
        });
      } catch (error) {
        // eslint-disable-next-line
        console.error(JSON.stringify({ error }));
      }
    }
  }
};
